import { render, staticRenderFns } from "./AuctionPropertyYN.vue?vue&type=template&id=47495012"
import script from "./AuctionPropertyYN.vue?vue&type=script&lang=js"
export * from "./AuctionPropertyYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports